import { useCallback, useEffect, useRef } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import VOutSolonCard from "../../components/Cards/VOutSolonCard";
import { applyOutSolonChange, saveOutSolonCase } from "../../features/outsolon/outsolonCase";

// VOutSolonCard in the desktop panel. Edits go to the loaded case (setData);
// saving posts it like ViewCaseOutSolon and mirrors the list columns back
// into the table row.
const OutSolonPanelBody = ({ data, setData, updateRow }) => {
  const axiosPrivate = useAxiosPrivate();
  const latestRef = useRef(data);
  useEffect(() => {
    latestRef.current = data;
  }, [data]);

  const modifySingleCase = useCallback(
    (change) =>
      setData((prev) => {
        const next = applyOutSolonChange(prev, change);
        latestRef.current = next;
        return next;
      }),
    [setData]
  );

  const saveCase = useCallback(async () => {
    const current = latestRef.current;
    try {
      await saveOutSolonCase(axiosPrivate, current);
      updateRow({
        note: current.note,
        diadikasia: current.diadikasia,
        katathesi: current.katathesi,
        extra_info: current.extra_info,
      });
    } catch (err) {
      console.error(err);
    }
  }, [axiosPrivate, updateRow]);

  return (
    <VOutSolonCard
      key={data.id}
      variant="panel"
      singleCase={data}
      modifySingleCase={modifySingleCase}
      saveCase={saveCase}
    />
  );
};

export default OutSolonPanelBody;
